import { combineReducers } from "redux";

import subsidybanner from "../features/admin/subsidypolicys/subsidybanner/Slice";

import newupdate from "../features/admin/subsidypolicys/newupdate/Slice";

import subsidybenefit from "../features/admin/subsidypolicys/subsidybenefit/Slice";

import subsidyregistrationprocess from "../features/admin/subsidypolicys/subsidyregistrationprocess/Slice";

import latestannouncement from "../features/admin/subsidypolicys/latestannouncement/Slice";

import electricity from "../features/admin/subsidypolicys/electricityconsumption/Slice";

import rooftopsolar from "../features/admin/subsidypolicys/rooftopsolar/Slice";

import common from "../features/admin/common/Slice";

const subsidypolicys = combineReducers({
  subsidybanner,
  newupdate,
  subsidybenefit,
  subsidyregistrationprocess,
  latestannouncement,
  electricity,
  rooftopsolar,
  common,
});

export default subsidypolicys;